{
  "name": "one-is-res",
  "version": "7.0.0",
  "scripts": {
    "ng": "ng",
    "serve": "node build-local-configuration.js && node git-version.js && node --trace-deprecation --max-old-space-size=8096 ./node_modules/@angular/cli/bin/ng serve --port 8000",
    "build.prod": "node pre-build.js && node git-version.js && node --max-old-space-size=8096 ./node_modules/@angular/cli/bin/ng build --configuration=production && node post-build.js",
    "build.preprod": "node pre-build.js && node git-version.js && node --max-old-space-size=8096 ./node_modules/@angular/cli/bin/ng build --configuration=production --source-map=true && node post-build.js",
    "test": "ng test",
    "lint": "ng lint"
  },
  "private": true,
  "dependencies": {
    "@angular/animations": "^19.2.25",
    "@angular/cdk": "^19.2.19",
    "@angular/common": "^19.2.25",
    "@angular/compiler": "^19.2.25",
    "@angular/core": "^19.2.25",
    "@angular/forms": "^19.2.25",
    "@angular/platform-browser": "^19.2.25",
    "@angular/platform-browser-dynamic": "^19.2.25",
    "@angular/router": "^19.2.25",
    "@fortawesome/fontawesome-free": "^6.1.1",
    "@kolkov/angular-editor": "^3.0.0-beta.2",
    "bootstrap": "^5.3.6",
    "chart.js": "^3.7.1",
    "chartjs-adapter-luxon": "^1.3.1",
    "d3": "^7.4.0",
    "devextreme": "24.2.16",
    "devextreme-angular": "24.2.16",
    "dexie": "^3.2.2",
    "exceljs": "^4.3.0",
    "file-saver": "^2.0.5",
    "lodash": "^4.17.21",
    "luxon": "^3.5.0",
    "ng2-charts": "^3.0.8",
    "ngx-capture": "^0.12.2",
    "powerbi-client": "^2.25.0",
    "powerbi-client-angular": "^6.0.3",
    "powerbi-models": "^2.2.0",
    "powerbi-report-authoring": "^3.0.0",
    "rxjs": "^7.5.5",
    "tslib": "^2.6.2",
    "uuid": "^14.0.3",
    "zone.js": "~0.15.1"
  },
  "devDependencies": {
    "@angular-devkit/build-angular": "^19.2.27",
    "@angular-eslint/eslint-plugin": "^13.1.0",
    "@angular-eslint/eslint-plugin-template": "^13.1.0",
    "@angular/cli": "^19.2.27",
    "@angular/compiler-cli": "^19.2.25",
    "@types/bootstrap": "^5.2.6",
    "@types/d3": "^7.4.0",
    "@types/file-saver": "^2.0.5",
    "@types/google.maps": "^3.64.1",
    "@types/lodash": "^4.14.181",
    "@types/luxon": "^2.3.1",
    "@types/node": "^17.0.29",
    "@types/uuid": "^8.3.4",
    "@typescript-eslint/eslint-plugin": "^5.17.0",
    "@typescript-eslint/eslint-plugin-tslint": "^5.17.0",
    "@typescript-eslint/parser": "^5.17.0",
    "eslint": "^8.12.0",
    "eslint-config-prettier": "^8.5.0",
    "eslint-plugin-import": "^2.25.4",
    "eslint-plugin-prefer-arrow": "^1.2.3",
    "jasmine-core": "~4.0.1",
    "karma": "^6.3.17",
    "karma-chrome-launcher": "~3.1.1",
    "karma-coverage": "~2.2.0",
    "karma-jasmine": "~4.0.2",
    "karma-jasmine-html-reporter": "^1.7.0",
    "ts-node": "~10.7.0",
    "typescript": "~5.8.3"
  },
  "allowScripts": {
    "core-js-pure@3.41.0": true,
    "inferno@7.4.11": true,
    "esbuild@0.25.12": true,
    "esbuild@0.28.0": true,
    "@parcel/watcher@2.6.0": true,
    "core-js@3.50.0": true,
    "lmdb@3.2.6": true,
    "msgpackr-extract@3.0.4": true
  }
}
